import { PAGE_CONSULENZA_SOCIALE_GIURIDICA, PAGE_CONSULENZA_HO_BISOGNO_DI_CONSULENZA, PAGE_HOME_INCLUSIONE, PAGE_HOME_URL } from 'types/url';

export const breadcrumbPath = [
  {
    slash: 'Home',
    url: PAGE_HOME_URL,
  },
  {
    slash: 'WeMi inclusione',
    url: PAGE_HOME_INCLUSIONE,
  },
  {
    slash: 'Consulenza sociale e giuridica',
    url: PAGE_CONSULENZA_SOCIALE_GIURIDICA,
  },
  {
    slash: 'HO BISOGNO DI CONSULENZA',
    url: PAGE_CONSULENZA_HO_BISOGNO_DI_CONSULENZA,
  },
];

export const title = 'WeMi - Inclusione - Consulenza sociale e giuridica - Ho bisogno di consulenza giuridica';
export const description = 'Descrizione servizio Ho bisogno di consulenza giuridica';
export const keywords = 'welfare, milano, servizi, servizio, Consulenza sociale e giuridica Ho bisogno di consulenza giuridica , servizio Consulenza sociale e giuridica, informazioni Consulenza sociale e giuridica, informazioni Ho bisogno di consulenza giuridica';
